import input from "./input";
import interpreter from "./interpreter";
import isRunning from "./isRunning";
import programs from "./programs";
import source from "./source";
import user from "./user";

export default {
  input,
  interpreter,
  isRunning,
  programs,
  source,
  user,
};



// WEBPACK FOOTER //
// ./reducers/index.ts